import type { BaseOptionType } from 'antd/es/select';
import { useMemo, useState } from 'react';

import type { LANGUAGE } from '@/types/commonConst';
import { getLanguageList } from '@/utils/getLanguageList';

const useWorkspaceLanguageSelect = (
  initialLanguage?: LANGUAGE,
): [
  BaseOptionType[],
  LANGUAGE | undefined,
  (value: LANGUAGE | undefined) => void,
] => {
  const languageList = getLanguageList();

  const langOptions: BaseOptionType[] = useMemo(() => {
    return languageList.map((lang) => {
      return {
        value: lang.code,
        label: lang.name,
      };
    });
  }, [languageList]);

  const [selected, setSelected] = useState<LANGUAGE | undefined>(
    initialLanguage || langOptions[0]?.value,
  );

  return [langOptions, selected, setSelected];
};

export default useWorkspaceLanguageSelect;
